/**
 * @param props
 */

export default (props) => {
    return {
        name: '',
        playlists: [],
        message: null,
        error: false,
        success: false,
        loading: false,
        mounted() {
            fetch(this.service.video.playlists.display)
                .then((r) => r.json())
                .then((r) => {
                    this.playlists = r.items;
                });
        },
        create() {
            this.loading = true;
            fetch(this.service.video.playlists.create,{
                    headers: {
                        "Content-Type": "application/json",
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    method: "POST",
                    body: JSON.stringify({
                        [this.service.video.csrfToken.name]: this.service.video.csrfToken.value,
                        movie_id: this.service.video.id,
                        name: this.name,
                    })
                })
                .then((data) => {
                    return data.json();
                })
                .then((data) => {
                    this.playlists = data.items;
                    this.loading = false;
                    this.message = data.service.message;
                    this.success = data.success;
                    this.error = data.error;
                    this.name = null;
                })
        },
        toggle(playlist) {
            fetch(!playlist.has_movie ? this.service.video.playlists.add : this.service.video.playlists.remove,
                {
                    headers: {
                        "Content-Type": "application/json",
                        'X-Requested-With': 'XMLHttpRequest'
                    },
                    method: "POST",
                    body: JSON.stringify({
                        [this.service.security.csrfToken.name]: this.service.security.csrfToken.value,
                        movie_id: this.service.video.id,
                        playlist_id: playlist.playlist_id,
                    })
                })
                .then((data) => {
                    return data.json();
                })
                .then((data) => {
                    this.loading = false;
                    this.message = data.service.message;
                    this.success = data.success;
                    this.error = data.error;
                    if (this.success) {
                        playlist.has_movie = !playlist.has_movie;
                    }
                })

        }
    }
};
